<div class="productDetail">
  <h3>Products</h3>
  <input autofocus class="standardTextBox" [(ngModel)]="searchTerm" placeholder="Search Term"
    (keyup)="handleKeyUp($event)"/>
  <button class="standardButton" [disabled]="(isBusy() || !searchTerm || searchTerm.length < 3)" (click)="search()">
    Search
  </button>
  <button class="standardButton" [disabled]="(isBusy())" (click)="newProduct()">New Product</button>
  @if (isBusy()) {
    <div class="busyIndicator">
      <mat-progress-spinner diameter="24" mode="indeterminate" strokeWidth="1"></mat-progress-spinner>
      <label class="busyLabel">Please Wait...</label>
    </div>
  }
  @if (searchResults()) {
    <div class="results">
      <table class="reportTable">
        <thead>
          <tr>
            <td class="tableCell centeredCell headerCell">Product ID</td>
            <td class="tableCell centeredCell headerCell">Description</td>
            <td class="tableCell centeredCell headerCell">Brand</td>
          </tr>
        </thead>
        @for (result of searchResults(); track result) {
          <tr>
            <td class="tableCell"><a routerLink="/product/{{result.id}}/{{ result.brandID }}">{{ result.id }}</a></td>
            <td class="tableCell">{{ result.description }}</td>
            <td class="tableCell">{{ result.brandID }}</td>
          </tr>
        }
      </table>
    </div>
  }
</div>
